import React from "react";
import { graphql } from "react-relay";

import { commitMutation } from "relay-runtime";

import { environment } from "~/models";
import { useModals } from "~/ui";
import Menu from "~/ui/menu";

import type { ModalData } from "./CreateEditGroupModal";
import CreateEditGroupModal from "./CreateEditGroupModal";

import type { CreateGroupButtonMutation } from "~/__generated__/CreateGroupButtonMutation.graphql";
import type { HomePanelGroupsMenu_object$data } from "~/__generated__/HomePanelGroupsMenu_object.graphql";

export const CreateGroupMutation = graphql`
	mutation CreateGroupButtonMutation($name: String!, $emoji: String, $objectId: String) {
		createGroup(name: $name, emoji: $emoji, objectId: $objectId) {
			group {
				id
				user {
					internalAttributes {
						# FIXME: Is this needed at all?
						username
					}
				}
				emojiName
				name
				type
				order
			}
			contentObject {
				...HomePanelGroupsMenu_object
			}
			viewer {
				...HomePanelGroupsMenu_viewer
				homePanelGroups {
					order
					...HomePanelGroup_group
				}
			}
		}
	}
`;

type Props = {
	eventId?: string;
	object?: HomePanelGroupsMenu_object$data | null;
};

export default function CreateGroupButton(props: Props) {
	const { object, eventId } = props;
	const modals = useModals();

	const createGroup = React.useCallback(async () => {
		const result = await modals.open<ModalData>(({ close }) => <CreateEditGroupModal onClose={close} />);

		if (!result) return;

		commitMutation<CreateGroupButtonMutation>(environment, {
			mutation: CreateGroupMutation,
			variables: { name: result.name, emoji: result.emoji, objectId: object?.id || eventId },
		});
	}, [eventId, modals, object?.id]);

	return <Menu.Item onSelect={createGroup}>Create new group…</Menu.Item>;
}
